// @flow
import { connect } from 'react-redux';
import Locale from '../components/LocaleComponent';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale.locale,
  };
}

export default connect(mapStateToProps)(Locale);



// WEBPACK FOOTER //
// ./src/modules/locale/containers/LocaleContainer.js